/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryStatusEmailConfigDto } from '../../models/delivery-status-email-config-dto';

export interface DeliveryStatusControllerSetEmailConfiguration$Params {
  id: number;
      body: DeliveryStatusEmailConfigDto
}

export function deliveryStatusControllerSetEmailConfiguration(http: HttpClient, rootUrl: string, params: DeliveryStatusControllerSetEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deliveryStatusControllerSetEmailConfiguration.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deliveryStatusControllerSetEmailConfiguration.PATH = '/delivery-status/{id}/email-configuration';
